import { render } from "./EditorView.vue?vue&type=template&id=4610f50a"
import script from "./EditorView.vue?vue&type=script&lang=js"
export * from "./EditorView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__